var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-header panel-header-lg"},[_c('header-chart',{attrs:{"height":255,"data":_vm.chartData,"labels":_vm.chartLabels}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }